import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ThumbsUpFilledSvg = function ThumbsUpFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.83 6.172-1.112 4.172H2V22h15.429l2.28-6.734L22 8.502c.01-.024-.88-.03-4.401-.03h-4.413V7.098c0-1.426-.01-1.615-.105-2.002a4.3 4.3 0 0 0-.67-1.458 3.9 3.9 0 0 0-2.124-1.494c-.402-.11-.512-.12-1.445-.132L7.942 2zM3.432 16.16v4.348h2.114v-8.695H3.432z",
    clipRule: "evenodd"
  }));
};
export var ThumbsUpFilled = function ThumbsUpFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ThumbsUpFilledSvg
  }));
};